"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _pick = _interopRequireDefault(require("lodash/fp/pick"));

var _throttle = _interopRequireDefault(require("lodash/throttle"));

var _react = _interopRequireWildcard(require("react"));

var _formik = require("formik");

var _recompose = require("recompose");

var _styledComponents = require("styled-components");

var _elementClass = _interopRequireDefault(require("element-class"));

var _Group = _interopRequireDefault(require("@emcasa/ui/lib/components/Group"));

var _constants = require("./constants");

var _styles = require("./styles");

var _Breakpoint = require("../Breakpoint");

var _Row = _interopRequireDefault(require("../Row"));

var _class, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ESC_KEY = 27;
var isBrowser = typeof window !== 'undefined';
var FilterGroup = (0, _Group["default"])((0, _pick["default"])(['onSelect', 'selected', 'selectedValue', 'disabled', 'isMobile', 'initialValues']), function (node) {
  return node.props.name;
})((_temp = _class =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(FilterGroup, _PureComponent);

  function FilterGroup() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, FilterGroup);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(FilterGroup)).call.apply(_getPrototypeOf2, [this].concat(_args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "bodyRef", _react["default"].createRef());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "contentRef", _react["default"].createRef());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "containerRef", _react["default"].createRef());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      bodyHeight: 0
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "measureBody", (0, _throttle["default"])(function () {
      var element = _this.bodyRef.current;
      if (element) _this.setState({
        bodyHeight: element.offsetHeight || element.height
      });
    }, 100));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onKeyPress", function (e) {
      if (_this.props.selectedValue && e.keyCode === ESC_KEY) {
        _this.props.formikRef.current.handleReset();

        _this.props.onSelect(undefined);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onSubmit", function (values) {
      if (_this.props.onSubmit) _this.props.onSubmit(values);

      _this.setState({
        initialValues: values
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onExpandRow", function () {
      return _this.setState({
        isRowExpanded: true
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onCollapseRow", function () {
      return _this.setState({
        isRowExpanded: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getFilterData", function (name) {
      var _this$props = _this.props,
          initialValues = _this$props.initialValues,
          selectedValue = _this$props.selectedValue,
          formikRef = _this$props.formikRef;
      var value = formikRef.current ? formikRef.current.state.values[name] : _this.state.initialValues[name];
      return {
        name: name,
        value: value,
        initialValue: initialValues[name],
        selected: name === selectedValue
      };
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "sortFilters", function (a, b) {
      var _this$props2 = _this.props,
          sort = _this$props2.sort,
          order = _this$props2.order;
      var args = [_this.getFilterData(a.props.name), _this.getFilterData(b.props.name)];
      if (typeof sort === 'function') return sort.apply(void 0, args);

      if (typeof order === 'function') {
        var aPriority = order(args[0]);
        var bPriority = order(args[1]);
        if (aPriority > bPriority) return -1;else if (aPriority < bPriority) return 1;
      }

      return 0;
    });
    return _this;
  }

  (0, _createClass2["default"])(FilterGroup, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      if (prevState.isFilterExpanded !== this.state.isFilterExpanded) {
        var callback = this.state.isFilterExpanded ? this.props.onExpandFilter : this.props.onCollapseFilter;
        if (callback) callback(this.state); // Collapse row when mobile filter closes

        if (this.state.isRowExpanded) {
          requestAnimationFrame(function () {
            return _this2.setState({
              isRowExpanded: false
            });
          });
        } // Disable container scroll when mobile filter opens


        if (this.props.scrollContainer) {
          var classNames = (0, _elementClass["default"])(this.props.scrollContainer);
          if (this.state.isFilterExpanded) classNames.add('noscroll');else classNames.remove('noscroll');
        }
      }

      if (prevState.isRowExpanded !== this.state.isRowExpanded) {
        var _callback = this.state.isRowExpanded ? this.props.onExpandRow : this.props.onCollapseRow;

        if (_callback) _callback(this.state);
      }

      if (this.props.onLayout && (prevState.height !== this.state.height || prevState.bodyHeight !== this.state.bodyHeight)) {
        // Trigger onLayout when height changes
        this.props.onLayout(this.state);
      } // Update expanded row height


      if (prevProps.selectedValue !== this.props.selectedValue) {
        requestAnimationFrame(this.measureBody);
      } // Reinitialize formik initial values


      if (!(0, _isEqual["default"])(prevProps.initialValues, this.props.initialValues)) {
        this.setState({
          initialValues: this.props.initialValues
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.bodyRef.current) this.measureBody();

      if (isBrowser) {
        window.addEventListener('keyup', this.onKeyPress);
        window.addEventListener('resize', this.measureBody);
      }

      if (this.props.onLayout) this.props.onLayout(this.state);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (isBrowser) {
        window.removeEventListener('keyup', this.onKeyPress);
        window.removeEventListener('resize', this.measureBody);
      }
    }
  }, {
    key: "renderFilters",
    value: function renderFilters() {
      var _this3 = this;

      var children = this.props.children;
      var _this$state = this.state,
          rowCount = _this$state.rowCount,
          isFilterExpanded = _this$state.isFilterExpanded,
          isRowExpanded = _this$state.isRowExpanded;

      var filters = _react["default"].Children.map(children, function (element) {
        return _react["default"].cloneElement(element, {
          rowCount: rowCount,
          isRowExpanded: isRowExpanded,
          isFilterExpanded: isFilterExpanded,
          contentRef: _this3.contentRef,
          containerRef: _this3.containerRef
        });
      });

      if (this.state.sort) return filters.sort(this.sortFilters);
      return filters;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props3 = this.props,
          id = _this$props3.id,
          style = _this$props3.style,
          className = _this$props3.className,
          fluid = _this$props3.fluid,
          width = _this$props3.width,
          zIndex = _this$props3.zIndex,
          zIndexActiveOffset = _this$props3.zIndexActiveOffset,
          showMobileHeader = _this$props3.showMobileHeader,
          selectedValue = _this$props3.selectedValue,
          onSelect = _this$props3.onSelect;
      var _this$state2 = this.state,
          initialValues = _this$state2.initialValues,
          bodyHeight = _this$state2.bodyHeight,
          rowCount = _this$state2.rowCount,
          isFilterExpanded = _this$state2.isFilterExpanded,
          isRowExpanded = _this$state2.isRowExpanded;
      var hasSelectedValue = Boolean(selectedValue);
      var isRowVisible = showMobileHeader || !isFilterExpanded;
      return _react["default"].createElement(_formik.Formik, {
        enableReinitialize: true,
        ref: this.props.formikRef,
        initialValues: initialValues,
        onSubmit: this.onSubmit
      }, function (form) {
        return _react["default"].createElement(_styles.Container, {
          hasSelectedValue: hasSelectedValue,
          style: style,
          className: className,
          width: width,
          zIndex: zIndex + (hasSelectedValue ? zIndexActiveOffset : 0)
        }, _react["default"].createElement(_styles.Form, (0, _extends2["default"])({
          id: id,
          fluid: fluid,
          zIndex: isRowVisible ? 1 : 0,
          ref: _this4.containerRef,
          pose: isRowVisible && isFilterExpanded ? 'filterOpen' : 'filterClosed',
          initialPose: "filterClosed",
          onSubmit: function onSubmit(e) {
            e.preventDefault();
            form.handleSubmit(e);
          }
        }, _this4.state), _react["default"].createElement(_styles.BodyExpander, {
          poseKey: isRowExpanded ? bodyHeight : 0,
          pose: isRowExpanded ? 'rowOpen' : 'rowClosed',
          initialPose: "rowClosed",
          height: bodyHeight
        }, _react["default"].createElement(_styles.Body, {
          ref: _this4.bodyRef
        }, _this4.renderFilters())), _react["default"].createElement(_Row["default"], {
          pt: 2
        }, rowCount > 1 && _react["default"].createElement(_styles.ExpandButton, {
          isRowExpanded: isRowExpanded,
          onClick: !isRowExpanded ? _this4.onExpandRow : _this4.onCollapseRow
        }))), _react["default"].createElement(_styles.Content, {
          ref: _this4.contentRef,
          visible: Boolean(selectedValue),
          row: {
            expanded: isRowExpanded,
            visible: isRowVisible
          },
          offset: bodyHeight
        }), _react["default"].createElement(_styles.Background, {
          pose: selectedValue ? 'bgOpen' : 'bgClosed',
          row: {
            expanded: isRowExpanded,
            visible: isRowVisible
          },
          offset: bodyHeight,
          onDismiss: function onDismiss() {
            form.handleReset();
            onSelect(undefined);
          }
        }));
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var rowHeight = state.rowHeight || (0, _constants.BUTTON_HEIGHT)(props) + props.theme.space[2];
      var rowCount = Math.ceil(state.bodyHeight / rowHeight) || 1;
      var sort = typeof props.sort === 'undefined' ? props.isMobile : props.sort;
      return {
        sort: sort,
        height: state.isRowExpanded ? state.bodyHeight : rowHeight,
        rowHeight: rowHeight,
        rowCount: rowCount,
        isFilterExpanded: props.isMobile && Boolean(props.selectedValue),
        isRowExpanded: rowCount > 1 ? state.isRowExpanded : false,
        initialValues: props.values || state.initialValues || props.initialValues || {}
      };
    }
  }]);
  return FilterGroup;
}(_react.PureComponent), (0, _defineProperty2["default"])(_class, "defaultProps", {
  zIndex: 1,
  zIndexActiveOffset: 100,
  initialValues: {},
  contentRect: {
    bounds: {}
  },
  strategy: 'switchable',
  showMobileHeader: false,
  onSubmit: function onSubmit() {
    return null;
  },
  order: function order(_ref) {
    var value = _ref.value,
        initialValue = _ref.initialValue,
        selected = _ref.selected;
    return selected ? 2 : value && !(0, _isEqual["default"])(value, initialValue) ? 1 : 0;
  },

  get scrollContainer() {
    return !isBrowser ? undefined : window.document.body;
  },

  get formikRef() {
    return _react["default"].createRef();
  }

}), _temp));

var _default = (0, _recompose.compose)(function (Target) {
  return _react["default"].forwardRef(function (props, ref) {
    return _react["default"].createElement(Target, (0, _extends2["default"])({
      innerRef: ref
    }, props));
  });
}, (0, _recompose.mapProps)(function (_ref2) {
  var onSelectFilter = _ref2.onSelectFilter,
      selectedFilter = _ref2.selectedFilter,
      props = (0, _objectWithoutProperties2["default"])(_ref2, ["onSelectFilter", "selectedFilter"]);
  return _objectSpread({
    onChange: onSelectFilter,
    selectedValue: selectedFilter
  }, props);
}), (0, _Breakpoint.withBreakpoint)(), _styledComponents.withTheme)(FilterGroup);

exports["default"] = _default;